import * as React from 'react';
import { Typography, Stack } from '@mui/material';
import './index.css';

export default function LoaderThreeDots(props: { title: string }) {
  return (
    <Stack display="flex" justifyContent="center" alignItems="center">
      <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <Typography sx={{ ml: 1 }}>{props.title}</Typography>
    </Stack>
  );
}
